<style>
.ql-bubble .ql-tooltip {
  background-color: #444;
  position: fixed;
  border-radius: 25px;
  color: #fff;
  display: fix;
  z-index: 99999999 !important;
}

.ql-editor {
  overflow-y: auto;
  width: 21cm;
  height: 29.7cm;
}

.signature-pad {
  border: 1px solid #ccc;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
.ql-mention-list-container {
  width: 370px;
}
.ql-editor ol li:not(.ql-direction-rtl),
.ql-editor ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em;
  padding-bottom: 20px;
}
.ql-divider:after {
  content: "-";
}
.ql-editor hr {
    border: none;
    color: #111;
    letter-spacing: 1em;
    text-align: center;
}

.ql-editor {
  counter-reset: number;
}
.ql-editor hr {
  counter-increment: number;
}
.ql-editor hr:before {
  content: '..... PAGE ' counter(number) ' .....';
}
@media print {
  hr {
      page-break-after: always; 
      display: none;
  }
}
</style>

<template>
  <v-container fluid grid-list-lg grid-list-md>
    <v-snackbar v-model="snackbar" :timeout="3000" top="top" vertical="vertical">
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-layout row wrap>
      <v-flex xs12 sm8 md4>
        <v-text-field label="Template Name" placeholder=" " box v-model="freeDomain.name"></v-text-field>
      </v-flex>
      <v-flex xs12 md1>
        <v-btn color="purple" dark @click="save">Save Template</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap style="background: rgb(204,204,204); padding: 10px; ">
      <div
        style="width: 21cm; margin: auto; background: white; box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);"
      >
        <quill-editor
          align-center
          class="legalworkflow editor-example bubble"
          v-model="content"
          ref="myQuillEditor"
          :options="editorOption"
          @change="onEditorChange($event)"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @ready="onEditorReady($event)"
        ></quill-editor>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import { Quill } from "vue-quill-editor";
//import {ImageDrop}from 'quill-image-drop-module';
import Mention from "quill-mention";
// import ImageDrop from 'quill-image-drop-module';
//import ImageResize  from "quill-image-resize-module";
// window.Quill = Quill;
//Quill.register('modules/imageDrop', ImageDrop);
Quill.register("modules/mention", Mention);
//Quill.register("modules/imageResize", ImageResize);

let BlockEmbed = Quill.import('blots/block/embed');

class DividerBlot extends BlockEmbed { }
DividerBlot.blotName = 'divider';
DividerBlot.tagName = 'hr';

Quill.register(DividerBlot);

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "quill-mention/dist/quill.mention.min.css";

import { upsertContent, getContent, createContent } from "@/models/freedomain";
import JwtService from "@/services/jwt.service";

const atValues = [
  { id: "companyName", value: "Company Name" },
  { id: "companyAddress", value: "Company Address" },
  { id: "companyPricePerShare", value: "Company Price Per Share " },
  { id: "companyNumberOfShares", value: "Company Number Of Shares " },
  { id: "companySecretary", value: "Company Secretary" },
  { id: "companyShareValue", value: "Company Share Value" },
  { id: "companyShareValueInWords", value: "Company Share Value (In Words)" },
  { id: "companySecretary", value: "Company Secretary" },
  { id: "buyerName", value: "Buyer Name" },
  { id: "buyerAddress", value: "Buyer Address" },
  { id: "sellerName", value: "Seller Name" },
  { id: "sellerAddress", value: "Seller Address" },
  { id: "propertyPrice", value: "Property Price" },
  { id: "propertyAddress", value: "Property Address" },
  { id: "shareholderDetails", value: "Shareholder Details" },
  { id: "directorDetails", value: "Director Details" },
  { id: "registerationDate", value: "Registeration Date" }
];
const hashValues = [];

import { quillEditor } from "vue-quill-editor";
let table = "lw_contract_templates";
let freeDomain = createContent();
let content = { name: "", description: "", html: "" };

// console.log(freeDomain);
freeDomain.content = Object.assign({ ...content }, freeDomain.content);
freeDomain.hydrateForApi();

export default {
  props: ["chart"],
  data: function() {
    const that = this;
    return {
      mentionList: [],
      snackbarText: "",
      snackbar: false,
      tableName: null,
      options: {
        penColor: "#000"
      },
      freeDomain: freeDomain,
      content: freeDomain.content.html,
      editorOption: {
        // theme: 'bubble',
        theme: "snow",
        modules: {
          mention: {
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            mentionDenotationChars: ["@", "#"],
            source: function(searchTerm, renderList, mentionChar) {

              let values;

              if (mentionChar === "@") {
                values = atValues;
              } else {
                values = hashValues;
              }

              if (searchTerm.length === 0) {
                renderList(values, searchTerm);
              } else {
                const matches = [];
                for (let i = 0; i < values.length; i++)
                  if (
                    ~values[i].value
                      .toLowerCase()
                      .indexOf(searchTerm.toLowerCase())
                  )
                    matches.push(values[i]);
                renderList(matches, searchTerm);
              }
            }
          },
          toolbar: {
          container: [
            [
              {
                size: ["small", false, "large"]
              }
            ],
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],

            [
              {
                header: 1
              },
              {
                header: 2
              }
            ], // custom button values
            [
              {
                list: "ordered"
              },
              {
                list: "bullet"
              }
            ],
            [
              {
                script: "sub"
              },
              {
                script: "super"
              }
            ], // superscript/subscript
            [
              {
                indent: "-1"
              },
              {
                indent: "+1"
              }
            ], // outdent/indent
            [
              {
                direction: "rtl"
              }
            ], // text direction

            [
              {
                color: []
              },
              {
                background: []
              }
            ], // dropdown with defaults from theme
            [
              {
                font: []
              }
            ],
            [
              {
                align: []
              }
            ],

            ["clean"],
            [
              {
                list: "ordered"
              },
              {
                list: "bullet"
              }
            ],
            ["image"],
            ["divider"]
          ],
           handlers: {
            divider: function() {
                const quill = this.quill;
                let range = quill.getSelection(true);
                quill.insertText(range.index, '\n', Quill.sources.USER);
                quill.insertEmbed(range.index + 1, 'divider', true, Quill.sources.USER);
                quill.setSelection(range.index + 2, Quill.sources.SILENT);
            }
        }
          },
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          }
          //imageDrop: true,
        //   imageResize: {
        //     displayStyles: {
        //       backgroundColor: "black",
        //       border: "none",
        //       color: "white"
        //     },
        //     // modules: [ 'Resize', 'DisplaySize', 'Toolbar' ]
        //     modules: ["DisplaySize", "Toolbar"]
        //   }
        }
      }
    };
  },
  components: {
    quillEditor
  },
  methods: {
    getMentionList() {

    },
    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
      // quill.theme.tooltip.edit();
      quill.theme.tooltip.show();
      return false;
    },
    onEditorReady(quill) {
      //console.log('editor ready!', quill)
    },
    onEditorChange({ quill, html, text }) {
      //console.log('editor change!', quill, html, text)
      this.element.setModel(html);
      //  this.content = html
      //  this.chart.changed(this.chart.parameters.content);
      //  console.log(this.chart.parameters.content.value);
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    clear() {
      this.$refs.signaturePad.clear();
    },
    async save() {
      this.freeDomain.content.html = this.content;
      await upsertContent(table, this.freeDomain);
      this.snackbarText = "Template Saved";
      this.snackbar = true;
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      // alert("Open DevTools see the save data.");
      console.log(isEmpty);
      console.log(data);
    },
    change() {
      this.options = {
        penColor: "#00f"
      };
    },
    resume() {
      this.options = {
        penColor: "#c0f"
      };
    },
    async get(id) {
      this.freeDomain = await getContent(table, id);
      this.freeDomain.content = Object.assign(
        { ...content },
        this.freeDomain.content
      );
      this.content = this.freeDomain.content.html;
    }
  },
  computed: {},
  mounted: function() {
    let params = this.$route.params;
    let query = this.$route.query;

    if (typeof params.id != "undefined") {
      this.get(params.id);
    }

    if (this.chart && typeof this.chart.data != "undefined") {
      this.tableName = this.chart.data.tableName;
      if (typeof this.chart.data.id != "undefined" && this.chart.data.id) {
        this.get(this.chart.data.id);
      }
      console.log("this.chart", this.chart);
    }
    // this.mSetProjectId(params.projectId);
    //  console.log('this is current quill instance object', this.myQuillEditor);
  },
  beforeDestroy() {}
};
</script>
